import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-saurabh-mittal',
  templateUrl: './saurabh-mittal.component.html',
  styleUrls: ['./saurabh-mittal.component.css']
})
export class SaurabhMittalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
